import { createContext, useContext } from "react";

/** What a page needs from the frame around it: opening the phone's ☰ menu. */
export interface ShellValue {
  openMenu: () => void;
}

export const ShellContext = createContext<ShellValue>({ openMenu: () => {} });

export function useShell(): ShellValue {
  return useContext(ShellContext);
}
